var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.38544C4.33236 1.30939 7.01327 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 9.52244 0.0334764 9.05269 0.0982106 8.59298C0.147033 8.24627 0.451666 8 0.801796 8C1.27821 8 1.62807 8.44641 1.56809 8.91903C1.52316 9.27302 1.5 9.63381 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5C7.40308 1.5 5.07817 2.66459 3.51903 4.5H5.25C5.66421 4.5 6 4.83579 6 5.25C6 5.66421 5.66421 6 5.25 6H1.75C1.33579 6 1 5.66421 1 5.25V1.75C1 1.33579 1.33579 1 1.75 1C2.16421 1 2.5 1.33579 2.5 1.75V3.38544ZM9.2284 6.18997C8.22861 5.63459 7 6.35755 7 7.50124V12.4992C7 13.6429 8.22861 14.3658 9.2284 13.8104L13.727 11.3115C14.7558 10.74 14.7558 9.26042 13.727 8.68893L9.2284 6.18997Z",
    fill: "#FFFBF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.794152e2fafe86b1eb9a2540e98d3677.svg";
export { ForwardRef as ReactComponent };